var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoDarkinline = function SvgInfoDarkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5.667A8.335 8.335 0 0 0 .167 9 8.333 8.333 0 0 0 8.5 17.333 8.333 8.333 0 1 0 8.5.667Zm0 3.696a1.411 1.411 0 1 1 0 2.822 1.411 1.411 0 0 1 0-2.822Zm1.882 8.535c0 .222-.18.403-.403.403H7.022a.403.403 0 0 1-.403-.403v-.807c0-.222.18-.403.403-.403h.403v-2.15h-.403a.403.403 0 0 1-.403-.404v-.806c0-.223.18-.403.403-.403h2.15c.223 0 .404.18.404.403v3.36h.403c.223 0 .403.18.403.403v.807Z",
    fill: "#00AFC5"
  })));
};
export default SvgInfoDarkinline;